import { PageListCachedDataSource } from './BaseDataSources';
import { IBidType } from '../Interfaces';

export class BidTypeSource extends PageListCachedDataSource<IBidType> {
  public constructor() {
    super('/datasource/bidtypes');
  }
}